// shared/guard/origin-currency.guard.ts
import { Injectable } from '@angular/core';
import {
  CanActivate, ActivatedRouteSnapshot,
  RouterStateSnapshot, Router, UrlTree
} from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class OriginGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {

  const origin   = this.auth.getOriginCurrency();
  const deny     = route.data['excludeOrigins']  as string[] | undefined;
  const allow    = route.data['allowedOrigins']  as string[] | undefined;

  if (deny?.length && deny.includes(origin)) {
    return this.router.parseUrl('/reports');
  }

  if (allow?.length && !allow.includes(origin)) {
    return this.router.parseUrl('/reports');
  }

  return true;                
    }
}
